/* eslint-disable-next-line no-undef */
const config = __APP_CONFIG__

export default () => ({
  namespaced: true,
  getters: {
    config: () => config
  }
})
